export default function (theme) {
    return {
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: theme.palette.primary.main
                },
                colorSecondary: {
                    color: theme.palette.text.disabled,
                    '&.Mui-checked': {
                        color: theme.palette.secondary.dark
                    }
                },
            }
        }
    };
}